export default __webpack_public_path__ + "static/media/arrow-drop-black.f15de90e.svg";